module.exports = __webpack_public_path__ + "img/gateway-skrill-logo.f611105d.svg";